import React from 'react'
import { useEffect, useState, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import { getSessionDataOnlyRead } from 'utils/common';
import { useDispatch, useSelector} from "react-redux";
import { TimerAndDate } from "../Navbars/TimerAndDatePage";
import {
  getSummaryOrderList,
} from "store/reducers/home.slice"
export default function MobileNewFooter() {
  const location = useLocation()
  const dispatch = useDispatch();
  const { isMasterRole} = useSelector(({ auth }) => auth);
  const {summaryOrderList, } = useSelector(({ home }) => home);
  const marginData = summaryOrderList?.[0];
  let sessionData = getSessionDataOnlyRead();
  const [showMargin, setShowMargin] = React.useState(false);
    useEffect(() => {
    if (showMargin && sessionData?.userId) {
      dispatch(
        getSummaryOrderList({
          userId: sessionData.userId,
          searchText: "",
          pageNo: 1,
          pageSize: 100000,
          appendData: false,
        })
      );
    }
  }, [showMargin, sessionData?.userId, dispatch]);
  const formatNumber = (num) => {
      if (num == null) return "-";
      return Number(num).toFixed(2);
  };
  const displayData = [
    ["Account Code", marginData?.accountCode],
    ["Ledger Balance", formatNumber(marginData?.ledgerBalance)],
    ["Live M2M", formatNumber(marginData?.liveM2M)],
    ["Net Balance", formatNumber(marginData?.netBalance)],
    ["Used Margin", formatNumber(marginData?.usedMargin)],
    ["Free Margin", formatNumber(marginData?.freeMargin)],
    ["CF Margin", formatNumber(marginData?.cfMargin)],
    ["Required CF Margin", formatNumber(marginData?.requiredCFMargin)],
  ];

  return (
    <>
    {showMargin && (<><div onClick={() => setShowMargin(false)} style={{position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 998 }} />
    <div style={{position: "fixed", bottom: 0, left: 0, right: 0, background: "#fff", borderTopLeftRadius: "20px", borderTopRightRadius: "20px", padding: "16px", zIndex: 999, animation: "slideUp 0.3s ease" }} >
      <div style={{ textAlign: "center", marginBottom: 10 }}>
        <div style={{
          width: 40,
          height: 4,
          background: "#ccc",
          borderRadius: 4,
          margin: "0 auto"
        }} />
      </div>
       {displayData.map(([label, value]) => (
        <div key={label} style={{display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #eee", }} >
        <span style={{ color: "#666" }}>{label}</span>
        <span style={{ fontWeight: 500 }}>{value}</span>
      </div>
    ))}
    </div>
  </>
)}

    <div>
  <div
    style={{
      position: "fixed",
      bottom: isMasterRole ? "60px" : "93px",
      left: 0,
      width: "100%",
      background: "#0b5c78",
      color: "#fff",
      textAlign: "center",
      padding: "2px 0",
      fontWeight: 600,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
    }}
    onClick={() => setShowMargin(true)}
  >
    <span>MARGIN</span>
    <span style={{ fontSize: "16px" }}>▲</span>
    <span>TABLE</span>
  </div>
      <div className='mfooter_wrap'>
        <ul>
          <li>
            <Link to="/app" className={location.pathname === "/app" ? 'active' : ''}>
              <span className="material-symbols-outlined">
                bar_chart
              </span>
              Watchlist
            </Link>
          </li>
          <li>
            <Link to="/app/order-book" className={location.pathname === "/app/order-book" ? 'active' : ''}>
              <span className="material-symbols-outlined">
                history
              </span>
              Order
            </Link>
          </li>
          <li>
            <Link to="/app/trade-book" className={location.pathname === "/app/trade-book" ? 'active' : ''}>
              <span className="material-symbols-outlined">
                work
              </span>
              Trades
            </Link>
          </li>
          <li>
            <Link to="/app/position-report" className={location.pathname === "/app/position-report" ? 'active' : ''}>
              <span className="material-symbols-outlined">
                analytics
              </span>
              Positions
            </Link>
          </li>
          <li>
            <Link to="/app/profile" className={location.pathname === "/app/profile" ? 'active' : ''}>
              <span className="material-symbols-outlined">
                person
              </span>
              {sessionData?.userName}
            </Link>
          </li>
        </ul>
        {!isMasterRole && (<div style={{textAlign: 'center', color: 'white', marginTop: '10px', fontWeight: 500, }} > <span>View Only</span> </div> )}
      </div>
    </div>
    </>
  )
}
